/**
 * GhostSprite - CSS-only ghost character
 * All ghosts are identical (cyan) for anonymity
 */

import type { GhostState } from '../../types/pacman';
import { TILE_SIZE } from '../../types/pacman';
import './GhostSprite.css';

interface GhostSpriteProps {
  ghost: GhostState;
}

export function GhostSprite({ ghost }: GhostSpriteProps) {
  return (
    <div
      className="ghost-sprite"
      style={{
        left: ghost.position.x - TILE_SIZE / 2,
        top: ghost.position.y - TILE_SIZE / 2,
      }}
    >
      <div className="ghost-eye ghost-eye--left" />
      <div className="ghost-eye ghost-eye--right" />
    </div>
  );
}
